<div class="modal-header">
  <h4 class="modal-title">{{ title || ("general.notice" | translate) }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus [innerHTML]="html | safe: 'html'"></div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.dismiss('Close click')">{{ closeText }}</button>
  @if (submitFn) {
    <button type="button" class="btn btn-primary" (click)="submit()">{{ submitText ? submitText : ("general.submit" | translate) }}</button>
  }
</div>
